import React from 'react';
import cx from 'classnames';
import Col from '../GridSystem/Col';
import styles from './Card.module.scss';

function CardHeader(props) {
  const { className, children, ...rest } = props;
  return (
    <Col xs={12} className={cx(styles.header, className)} {...rest}>
      {children}
    </Col>
  );
}

export default CardHeader;
